import styled from 'styled-components';

export const TooltipIconWrapper = styled.span`
  display: flex;
  cursor: pointer;
`;
